import cls from 'classnames'
import { useTranslation } from 'react-i18next'
import { FormTitle } from '@/pages/ProjectCreatePage/components/StepOne/StepOne'
import MiddleText from '@/components/MiddleText/MiddleText'
import VideoAnalysisChart from '../../VideoAnalysisChart/VideoAnalysisChart'
import styles from '../../VideoAnalysis.module.less'
import {
  PROFESSOR_RATE_BTN_ID_PREFIX,
  RateBtn,
} from '@/pages/ProfessorProjectDetailPage/components/ProfessorRatePanel/ProfessorRatePanel'

type Props = {
  chartRerender: boolean
  mode?: 'professor' | 'default'
  project: ProjectModels.ProjectDetail
  viewMode: 'realtime' | 'panoramic'
  onViewModeChange: (viewMode: 'realtime' | 'panoramic') => void
  onAxisClick: (second: number) => void
  onRateClick: () => void
}

function SubjectiveResponseCurveLandscape(props: Props) {
  const { t } = useTranslation()
  return (
    <>
      <FormTitle
        text={
          <>
            <span>
              <MiddleText text={t('dashboard.projectDetailPage.videoView.subjectiveResponseCurve')} />
            </span>
            <span className={styles.switchBtn}>
              <span className={cls(styles.viewBtn, props.viewMode === 'realtime' && styles.active)} onClick={() => {
                props.onViewModeChange('realtime')
              }}>
                <MiddleText text={t('dashboard.projectDetailPage.videoView.realtimeData')} />
              </span>
              <span className={cls(styles.viewBtn, props.viewMode === 'panoramic' && styles.active)} onClick={() => {
                props.onViewModeChange('panoramic')
              }}>
                <MiddleText text={t('dashboard.projectDetailPage.videoView.panoramicData')} />
              </span>
            </span>
            {props.mode === 'professor' && (
              <span id={`${PROFESSOR_RATE_BTN_ID_PREFIX}-subjectiveResponseCurve`}>
                <RateBtn
                  rateKey={'subjective_response_curve'}
                  style={{ marginLeft: 8 }}
                  onClick={props.onRateClick}
                />
              </span>
            )}
          </>
        }
        style={{ marginTop: 32 }}
      />

      <div className={styles.videoAnalysis}>
        {props.chartRerender && (
          <div className={styles.videoAnalysisChartWrapper}>
            <VideoAnalysisChart
              orientation='landscape'
              viewMode={props.viewMode}
              mode={props.mode}
              project={props.project}
              onAxisClick={props.onAxisClick}
            />
          </div>
        )}
        <div className={styles.legendBox}></div>
      </div>
    </>
  )
}

export default SubjectiveResponseCurveLandscape
